
export default {
    getAreaTree: state => state.areatree,
    getClassCode: state => state.classcode,
    getSubmitHospital: state => state.submitHospital,
    getAreaHospitalByParam: state => state.areahospital,
    getCreateHosInfo: state => state.createHosInfo
}